<template>
  <div class="share">
    <Nav :title="$t('邀请')" :leftArrow="false"></Nav>
    <div class="share_content">
      <div class="share_contentCase">
        <img :src="verConfig.url +
          'api/other/qrcode?text=' +
          encodeURIComponent(this.shareUrl)
          " alt="" />
        <div class="text_id">
          {{ $t("My.MemberInformation.Invitation") }}(ID)
          <div class="share_code">
            {{ userInfo.share_code }}
          </div>
        </div>
        <!-- 邀请网站 -->
        <div class="url">
          <div class="url_text">
            {{ shareUrl }}
          </div>
        </div>
        <div class="text_hb"></div>
        <div class="url_btn" @click="copy">
          {{ $t("newAdd.copy") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/JNav.vue";
import { Toast } from "vant";
import { GET_CONFIG_INFO } from "@/api"
import { mapGetters } from "vuex";
export default {
  components: { Nav },
  data() {
    return {
      // shareUrl: '',
      sid: '',
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    shareUrl() {
      return window.location.origin + '/#/registrasi?id=' + this.userInfo.share_code
    },
  },
  methods: {
    copy() {
      this.$copyText(this.shareUrl).then(() => {
        Toast(this.$t('复制成功'));
      });
    },
    getConfigShare() {
      Toast.loading();
      GET_CONFIG_INFO({
        act: "share",
      })
        .then((r) => {
          Toast.clear();
          if (r.data.ret === 1) {
            this.shareUrl = r.data.data.text;
            console.log(r.data.data.text);

            this.$cookie.set("public-share-item", JSON.stringify(r.data.data));
          } else {
            this.shareUrl = "";
            this.$cookie.set("public-share-item", {});
          }
        })
        .catch((e) => {
          console.error(e);
          this.loadingNum--;
        });
    },
  },
  created() {
    this.$store.dispatch('getuserInfo')
    // this.shareUrl = (JSON.parse(localStorage.getItem("public-share-item")) && JSON.parse(localStorage.getItem("public-share-item")).text) || ''
    // this.getConfigShare();
    // if(!this.shareUrl){
    // }
    // this.sid = JSON.parse(localStorage.getItem("userInfo")).id
  },
};
</script>

<style lang="less" scoped>
@Color: #e23d6d;

// 弹性布局
.flex(@JC: center; @FW: nowrap; @AI: center; @FD: row) {
  display: flex;
  flex-wrap: @FW;
  flex-direction: @FD;
  justify-content: @JC;
  align-items: @AI;
}

// 文字超出省略号
.text-overflow(@num: 1) {
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: @num;
}

.share {
  // padding: 0 3vw;
  min-height: calc(100vh - 50px);
  // background: #13a9fe url(../../../assets/Img/myImg/site_27.35363508.png) no-repeat center -9.333vw;
  background: var(--bg);

  .share_content {
    position: relative;
    z-index: 3;
    padding: calc(16rem / 16);
    margin: 10% 8% 0;
    border-radius: 2.667vw;
    background: linear-gradient(180deg, #F3E8CD 0%, #FFFFFF 100%);
    .flex();

    .share_contentCase {
      // .flex(space-around, nowrap, center, column);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      img {
        border-radius: 6px;
        display: block;
      }

      .text_id {
        color: #957C45;
        padding: calc(16rem / 16) 0;
        .share_code{
          margin-top: 10px;
          font-size: 18px;
          font-weight: bold;
          text-align: center;
        }
      }
    }

    .text_hb {
      margin-top: 20px;
      height: 1px;
      width: 100%;
      border-top: 1px dashed #D4BB7B;
      position: relative;
      &::before{
        position: absolute;
        content: '';
        left: -32px;
        top: -16px;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background: #fff;
      }
      &::after{
        position: absolute;
        content: '';
        right: -32px;
        top: -16px;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background: #fff;
      }
    }

    .url {
      padding: calc(12rem / 16);
      overflow: hidden;
      color: #957C45;
      background: var(--light);
      border-radius: 8px;
      font-size: calc(14rem / 16);
      .flex(space-between);
    }
    .url_btn {
      width: 80%;
      background: var(--btn_bg);
      color: var(--light);
      height: 38px;
      line-height: 38px;
      margin: calc(26rem / 16) 8% 0;
      font-size: calc(14rem / 16);
      text-align: center;
      border-radius: 100px;
    }
  }

}
</style>
